module.exports = __webpack_public_path__ + "static/media/20210410_212706_739_IMG_0408.91d0a68d.jpg";